import { areInvalidElementsOnScreen } from "../helpers/areInvalidElementsOnScreen"

export const checkElementsVisibility = (container, abortHandler) => {
    if (areInvalidElementsOnScreen(container)) {
        abortHandler()
    }
}